// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2_pYO","actions":"GroupTable_actions__1_wPT","deleteModalFooter":"GroupTable_deleteModalFooter__3KBws"};